module.exports = __webpack_public_path__ + "img/icon-linkedin.69e28a40.svg";